<template>
    <div class="fluid">
        <h1 class="app-title">Cadastro de Regras de Pagamento - Exibir</h1>
        <b-card>
            <b-row class="mb-0">
                <b-col sm="12" md="3" class="mb-0">
                    <b-form-group
                        label="Receita:"
                        label-for="valor"
                        class="text-label">
                        <b-form-select disabled v-model="pagamento.receita" @change="pagamento.refiz = null">
                            <option
                                v-for="tc in dados.receitas"
                                :key="tc.id"
                                :value="tc">
                                {{ tc.nome ? tc.nome : 'NENHUM' }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="1" class="mt-3">
                    <label></label>
                    <b-form-group id="input-group" label label-for="refiz" v-if="validarRegraHabilitar([0, 1, 2, 3, 4, 5])">
                        <b-form-checkbox disabled v-model="pagamento.refiz" id="refiz" name="check-button" switch>
                            Refis
                        </b-form-checkbox>
                    </b-form-group>
                    <b-form-group id="input-delibSid" label label-for="delibSid">
                        <b-form-checkbox disabled v-model="pagamento.delibSid" id="delibSid" name="check-button" switch>
                            Campo Nº Deliberação Conselho e SID
                        </b-form-checkbox>
                    </b-form-group>
                </b-col>
                <b-col sm="2" md="5">
                    <b-form-group
                        label="Nome:"
                        label-for="nome"
                        class="text-label">
                        <b-form-input disabled v-model="pagamento.descricao" type="text" id="nome" maxlength="250" />
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row class="mb-0" style="margin-top: 10px;">
                <b-col sm="12" md="2">
                    <p class="mb-0">
                        <b>Vigência:</b>
                    </p>
                    <label for="dataInicial">
                        Data Inicial:
                    </label>
                    <b-input disabled v-model="pagamento.dataInicialVigencia" id="dataInicial" type="date" placeholder></b-input>
                </b-col>
                <b-col sm="12" md="2">
                    <p class="mb-0">&nbsp;</p>
                    <label for="dataFinal">
                        Data Final:
                    </label>
                    <b-input disabled v-model="pagamento.dataFinalVigencia" id="dataFinal" type="date" placeholder></b-input>
                </b-col>
                <b-col sm="12" md="8"  v-if="validarRegraHabilitar([0, 1, 2, 3, 4, 5])">
                    <p class="mb-0">&nbsp;</p>
                    <p>
                        Base de cálculo:
                    </p>
                    <b-form-group label>
                        <b-form-radio-group
                            disabled
                            id="radio-group-9"
                            v-model="pagamento.baseCalculo"
                            name="radio-baseCalculo">
                            <b-form-radio value="0">Valor Hist. do Aju/Pro atualizado</b-form-radio>
                            <b-form-radio value="1">Valor Pendente no FIR</b-form-radio>
                            <b-form-radio value="2" v-if="validarRegraHabilitar([1, 2, 4, 5, 6])">Valor Hist. do Aju/Pro atualizado c/ deduções REFIS</b-form-radio>
                            <b-form-radio value="3" v-if="validarRegraHabilitar([1, 2, 4, 5, 6])">Valor Pendente c/ deduções REFIS</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row style="margin-top: 10px;">
                <b-col sm="12" md="3">
                    <b-form-group
                        label="Valor Mínimo da Parcela (R$):"
                        label-for="valorminparc"
                        class="text-label">
                        <b-form-input disabled v-model="pagamento.valorMinimoParcela" type="text"/>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="3">
                    <b-form-group
                        label="Percentual Pré-fixado de Honorários:"
                        label-for="valorprefix"
                        class="text-label">
                        <b-form-input disabled v-model="pagamento.percentualHonorario" type="text"/>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group
                        label="Índice de Reajuste a sugerir:"
                        label-for="valorindica"
                        class="text-label" >
                        <b-form-select disabled v-model="pagamento.indice" class="mb-3">
                            <template v-slot:first>
                                <option :value="null">Selecionar</option>
                            </template>
                            <option
                                v-for="tc in dados.indices"
                                :key="tc.id"
                                :value="tc">
                                {{ tc.nome ? tc.nome : 'NENHUM' }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row style="margin-top: 10px;">
                <b-col sm="12" md="3">
                    <b-form-group
                        label="Número de Parcelas Atrasadas:"
                        label-for="numeroParcelasRescisao"
                        class="text-label">
                        <b-form-input
                            disabled
                            type="text"
                            id="numeroParcelasRescisao"
                            v-model="pagamento.numeroParcelasRescisao"
                            v-mask="['####']">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <b-form-group
                        label="Número de Dias de Atraso:"
                        label-for="numeroDiasAtrasoParcela"
                        class="text-label">
                        <b-form-input
                            disabled
                            type="text"
                            id="numeroDiasAtrasoParcela"
                            v-model="pagamento.numeroDiasAtrasoParcela"
                            v-mask="['####']">
                        </b-form-input>
                    </b-form-group>
                </b-col>
                <b-col sm="12" md="2">
                    <p>
                        Situação:
                    </p>
                    <b-form-group label>
                        <b-form-radio-group
                            disabled
                            id="radio-group-9"
                            v-model="pagamento.indAtivo"
                            name="radio-situacao" >
                            <b-form-radio value="true">Ativo</b-form-radio>
                            <b-form-radio value="false">Inativo</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <p>
                        Titular da Receita:
                        <span class="text-danger">*</span>
                    </p>
                    <b-form-group label>
                        <b-form-radio-group
                                id="radio-group-10"
                                v-model="pagamento.titularReceita"
                                name="radio-titularReceita" >
                            <b-form-radio value="0">FEPGE</b-form-radio>
                            <b-form-radio value="1">CES</b-form-radio>
                            <b-form-radio value="2">Ambos</b-form-radio>
                        </b-form-radio-group>
                    </b-form-group>
                </b-col>         
            </b-row>
        </b-card>
        <b-card title="Configuração - Faixas de Pagamento">
            <b-row class="d-flex justify-content-between">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="currentPageTipoPagamento" per-page="5" :total-rows="listaTipoPagamento.length" size="sm" class="pl-3" style="padding: 0 !important;" aria-controls="tiposPagamento">
                    </b-pagination>
                </b-col>
                <b-col>
                </b-col>
            </b-row>
            <b-table
                id="tiposPagamento"
                ref="tableTipoPagamento"
                :items="listaTipoPagamento"
                :fields="fieldsTipoPagamento"
                per-page="5"
                :current-page="currentPageTipoPagamento"
                striped
                small
                responsive
                :busy="false"
                show-empty
                hover
                bordered
                sort-icon-left
                class="mb-0"
                head-variant="light">
                <div slot="table-busy" class="text-center text-primary my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong> Carregando...</strong>
                </div>
                <template slot="empty">
                    <p class="my-auto">Nenhum tipo de pagamento encontrado.</p>
                </template>
                <template v-slot:cell(tipoPagamento)="{ item }">
                    {{ item.tipoPagamento != null ? item.tipoPagamento.nome : "" }}
                </template>
                <template v-slot:cell(tiposCredito)="{ item }">
                    <p v-for="tipoCredito in item.tiposCredito" :key="tipoCredito.id">
                        {{ tipoCredito.nome }}
                    </p>
                </template>
            </b-table>
        </b-card>
        <b-card title="CDA" v-if="pagamento.refiz">
            <b-row md="12" class="mb-3">
                <b-col sm="12" md="12">
                    <b-button v-if="pagamento.codPagamento != null"
                              v-b-modal.modal-busca-cda
                              variant="outline-secondary"
                              class="ml-2" @click="abrirModalCdas()">
                        <i class="fa fa-search"></i> CDA's já carregadas
                    </b-button>
                </b-col>
            </b-row>
        </b-card>
        <b-modal
            ref="modal-busca-cda"
            id="modal-busca-cda"
            size="xl"
            :content-class="'shadow ' + getTheme"
            :title="'CDA\'s carregadas para ' + (this.pagamento.descricao != null ? this.pagamento.descricao : '')"
            header-bg-variant="info"
            header-text-variant="white">
            <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <b-row class="d-flex justify-content-between">
                        <b-col>
                        </b-col>
                        <b-col style="display: flex; justify-content: center;">
                            <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage" aria-controls="tableCdaModal"
                                          :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;">
                            </b-pagination>
                        </b-col>
                        <b-col>
                        </b-col>
                    </b-row>
                    <b-table
                        id="tableCdaModal"
                        ref="tableCdaModal"
                        :items="listaCdasModal"
                        :fields="fieldsCdaModal"
                        striped
                        small
                        responsive
                        :busy="configTable.load"
                        show-empty
                        hover
                        bordered
                        sort-icon-left
                        :no-local-sorting="true"
                        class="mb-0"
                        head-variant="light">
                        <div slot="table-busy" class="text-center text-primary my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong> Carregando...</strong>
                        </div>
                        <template slot="empty">
                            <p class="my-auto">Nenhuma CDA encontrada.</p>
                        </template>
                        <template v-slot:head(numeroCda)="{ item }">
                            Número CDA <i class="filter" :class="!isEmpty(filtros.numeroCda) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Número CDA', 'mascara', '', '#########', $event)"></i>
                        </template>
                        <template v-slot:head(situacaoDivida)="{ item }">
                            Situação da Dívida <i class="filter" :class="!isEmpty(filtros.situacaoDivida) || filtros.filtrarSituacaoDivida == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação da Dívida', 'texto', '', null, $event)"></i>
                        </template>
                        <template v-slot:cell(situacaoDivida)="{ item }">
                            {{ item.situacaoDivida != null ? item.situacaoDivida.nome : "" }}
                        </template>
                        <template v-slot:head(status)="{ item }">
                            Status <i class="filter" :class="!isEmpty(filtros.statusCredito) || filtros.filtrarStatusCredito == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Status', 'texto', '', null, $event)"></i>
                        </template>
                        <template v-slot:cell(status)="{ item }">
                            {{ item.statusCredito != null ? item.statusCredito.nome : "" }}
                        </template>
                        <template v-slot:head(tipoCredito)="{ item }">
                            Tipo Crédito <i class="filter" :class="!isEmpty(filtros.tipoCredito) || filtros.filtrarTipoCredito == 3 ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Tipo Crédito', 'texto', '', null, $event)"></i>
                        </template>
                        <template v-slot:cell(tipoCredito)="{ item }">
                            {{ item.tipoCredito != null ? item.tipoCredito.nome : "" }}
                        </template>
                        <template v-slot:head(indAtivo)="{ item }">
                            Situação Cadastro <i class="filter" :class="!isEmpty(filtros.indAtivo) ? 'fa fa-filter' : 'filter-empty'" @click="openFilter('Situação Cadastro', 'radio', 'Ativo,Inativo', null, $event)"></i>
                        </template>
                        <template v-slot:cell(indAtivo)="{ item }">
                            {{ (item.indAtivo == "true" || item.indAtivo == true) ? "Ativo" : "Inativo" }}
                        </template>
                    </b-table>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="outline-primary" @click="hide('modal-busca-cda')"> <i class="fa fa-times"></i> Fechar</b-button>
            </template>
        </b-modal>
        <hr class="mt-2"/>
        <b-row class="center-xy">
            <b-button variant="outline-secondary" @click="voltar">
                <i class="fa fa-reply"></i> Voltar
            </b-button>
        </b-row>
        <CompLoading ref="loading"/>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import axios from 'axios'
import CompLoading from "../shared/components/CompLoading";
import formatarMixins from '../../mixins/formatarMixins';
import moment from 'moment';
import CompFiltroGrid from "../shared/components/CompFiltroGrid";

export default {
    components: {CompFiltroGrid, CompLoading, Multiselect},
    mixins: [ formatarMixins ],
    watch: {
        currentPage() {
            this.configTable.checkedAll = false;
            this.consultarCdas();
        },
        perPage() {
            this.configTable.currentPage = 1;
            this.consultarCdas();
        }
    },
    data() {
        return {
            urlApi: null,
            token: null,
            pagamento: {
                codPagamento: null,
                descricao: null,
                indAtivo: true,
                refiz: false,
                delibSid: false,
                dataInicialVigencia: null,
                dataFinalVigencia: null,
                receita: null,
                valorMinimoParcela: null,
                percentualHonorario: null,
                indice: null,
                arquivo: null,
                numeroParcelasRescisao: null,
                numeroDiasAtrasoParcela: null,
                baseCalculo: 0,
                titularReceita: null
            },
            dados: {
                indices: [],
                receitas: []
            },
            fieldsTipoPagamento: [
                {
                    key: 'descricao',
                    sortable: true,
                    label: 'Descrição.'
                },
                {
                    key: 'numeroMinimoParcelas',
                    sortable: true,
                    label: 'Nº Mínimo Parcelas'
                },
                {
                    key: 'numeroMaximoParcelas',
                    sortable: true,
                    label: 'Nº Máximo Parcelas'
                },
                {
                    key: 'tipoPagamento',
                    sortable: true,
                    label: 'Tipo Pagamento'
                },
                {
                    key: 'tiposCredito',
                    sortable: true,
                    label: 'Tipo Crédito'
                },
                {
                    key: 'percentualPrincipal',
                    sortable: true,
                    label: '% Desc Principal'
                },
                {
                    key: 'percentualDescontoMulta',
                    sortable: true,
                    label: '% Desc Multa'
                },
                {
                    key: 'percentualDescontoJuros',
                    sortable: true,
                    label: '% Desc Juros'
                }
            ],
            currentPageTipoPagamento: 1,
            listaTipoPagamento: [],
            configTable: {
                perPage: 10,
                lastPage: null,
                currentPage: 1,
                rows: 0,
                load: false,
                sortField: 'cdaPagamento.numeroCda',
                sortOrder: 'asc',
                checkedAll: false,
            },
            listaCdasModal: [],
            fieldsCdaModal: [
                {
                    key: 'numeroCda'
                },
                {
                    key: 'situacaoDivida'
                },
                {
                    key: 'status'
                },
                {
                    key: 'tipoCredito'
                },
                {
                    key: 'indAtivo'
                }
            ],
            filtro: {
                tipo: null,
                campoFiltro: null,
                filtrarEm: null,
                mascara: null,
                campoTexto: null,
                campoMascara: null,
                campoData: null,
                campoRadio: null,
                campoCheckbox: null,
                listaValores: []
            },
            filtros: {
                codPagamento: null,
                numeroCda: null,
                indAtivo: null,
                filtrarSituacaoDivida: null,
                situacaoDivida: null,
                filtrarStatusCredito: null,
                statusCredito: null,
                filtrarTipoCredito: null,
                tipoCredito: null,
            },
        }
    },
    computed: {
        getTheme () {
            return this.$store.getters.getTheme
        },
        currentPage() {
            return this.configTable.currentPage;
        },
        perPage() {
            return this.configTable.perPage;
        },
    },
    methods: {
        async listarIndicecs() {
            axios.get(`${this.urlApi}/v1/regrasPagamento/listarIndices`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.indices = response.data
            })
        },
        async listarReceitas() {
            axios.get(`${this.urlApi}/v1/regrasPagamento/listarReceitas`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                this.dados.receitas = response.data
            })
        },

        voltar(evt) {
            evt.preventDefault();
            this.$router.push({path: '/regras-pagamento'});
        },

        async obterPagamento(codPagamento) {
            await axios.get(`${this.urlApi}/v1/regrasPagamento/obter/` + codPagamento, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': this.token
                }
            }).then(response => {
                this.pagamento = {
                    codPagamento: response.data.codPagamento,
                    descricao: response.data.descricao,
                    indAtivo: response.data.indAtivo,
                    refiz: response.data.refiz,
                    delibSid: response.data.delibSid,
                    dataInicialVigencia: response.data.dataInicialVigenciaString,
                    dataFinalVigencia: response.data.dataFinalVigenciaString,
                    receita: response.data.receita,
                    valorMinimoParcela: this.formatarMonetarioExibir(response.data.valorMinimoParcela, 3, 2),
                    percentualHonorario: this.formatarMonetarioExibir(response.data.percentualHonorario, 3, 2),
                    indice: response.data.indice,
                    baseCalculo: response.data.baseCalculo,
                    arquivo: response.data.arquivo,
                    numeroParcelasRescisao: response.data.numeroParcelasRescisao,
                    numeroDiasAtrasoParcela: response.data.numeroDiasAtrasoParcela,
                    titularReceita: response.data.titularReceita,
                };

                this.listaTipoPagamento = response.data.listaTipoPagamento;
                this.listaTipoPagamento.forEach(el => {
                    el.numeroMinimoParcelas = this.formatarDecimalPositivo(el.numeroMinimoParcelas, 5, 0);
                    el.numeroMaximoParcelas = this.formatarDecimalPositivo(el.numeroMaximoParcelas, 5, 0);
                    el.percentualPrincipal = this.formatarMonetarioExibir(el.percentualPrincipal, 3, 2);
                    el.percentualDescontoJuros = this.formatarMonetarioExibir(el.percentualDescontoJuros, 3, 2);
                    el.percentualDescontoMulta = this.formatarMonetarioExibir(el.percentualDescontoMulta, 3, 2);
                    el.valorMinimoHonorario = this.formatarMonetarioExibir(el.valorMinimoHonorario, 3, 2);
                    el.valorMaximoHonorario = this.formatarMonetarioExibir(el.valorMaximoHonorario, 3, 2);
                });
            }).catch((error) => {
                this.exibirErro(error)
            })
        },

        validarRegraHabilitar(tiposValidacao) {
            if(this.pagamento.receita != null) {
                if(this.pagamento.receita.id == 1) {
                    if(!this.pagamento.refiz) {
                        return tiposValidacao.includes(0);
                    }

                    return this.pagamento.baseCalculo == 2 || this.pagamento.baseCalculo == 3 ? tiposValidacao.includes(2) : tiposValidacao.includes(1);
                }

                if(this.pagamento.receita.id == 2) {
                    if(!this.pagamento.refiz) {
                        return tiposValidacao.includes(3);
                    }

                    return this.pagamento.baseCalculo == 2 || this.pagamento.baseCalculo == 3 ? tiposValidacao.includes(5) : tiposValidacao.includes(4);
                }

                return tiposValidacao.includes(6);
            }

            return false;
        },

        openFilter(campo, tipo, values, mascara, event) {
            if(document.getElementById('popup').style.display == 'block'
                && this.filtro.campoFiltro == campo) {
                this.$refs.compFiltro.closeFilterPopup();
            } else {
                this.filtro.tipo = tipo;
                this.filtro.campoFiltro = campo;
                this.filtro.mascara = mascara;

                if(this.filtro.campoFiltro == 'Número CDA') {
                    this.filtro.campoMascara = this.filtros.numeroCda;
                } else if(this.filtro.campoFiltro == 'Situação da Dívida') {
                    this.filtro.filtrarEm = this.filtros.filtrarSituacaoDivida;
                    this.filtro.campoTexto = this.filtros.situacaoDivida;
                } else if(this.filtro.campoFiltro == 'Status') {
                    this.filtro.filtrarEm = this.filtros.filtrarStatusCredito;
                    this.filtro.campoTexto = this.filtros.statusCredito;
                } else if(this.filtro.campoFiltro == 'Tipo Crédito') {
                    this.filtro.filtrarEm = this.filtros.filtrarTipoCredito;
                    this.filtro.campoTexto = this.filtros.tipoCredito;
                } else if(this.filtro.campoFiltro == 'Situação Cadastro') {
                    this.filtro.campoRadio = this.filtros.indAtivo;
                }

                if(this.filtro.tipo == "checkbox") {
                    this.filtro.listaValores = values;
                } else if(values != null && values != "") {
                    this.filtro.listaValores = values.split(',');
                }

                this.$refs.compFiltro.openCloseFilterPopup(event, true, 380, 95);
            }
        },
        filtrarResultados(limpar) {
            if(limpar) {
                this.filtro.filtrarEm = null;
                this.filtro.campoTexto = null;
                this.filtro.campoData = null;
                this.filtro.campoRadio = null;
                this.filtro.campoCheckbox = null;
                this.filtro.campoMascara = null;
            }

            if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
            }

            if(this.filtro.campoFiltro == 'Número CDA') {
                this.filtros.numeroCda = this.filtro.campoMascara;
            } else if(this.filtro.campoFiltro == 'Situação da Dívida') {
                this.filtros.filtrarSituacaoDivida = this.filtro.filtrarEm;
                this.filtros.situacaoDivida = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Status') {
                this.filtros.filtrarStatusCredito = this.filtro.filtrarEm;
                this.filtros.statusCredito = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Tipo Crédito') {
                this.filtros.filtrarTipoCredito = this.filtro.filtrarEm;
                this.filtros.tipoCredito = this.filtro.campoTexto;
            } else if(this.filtro.campoFiltro == 'Situação Cadastro') {
                this.filtros.indAtivo = this.filtro.campoRadio;
            }

            this.consultarCdas();
        },
        ordenarResultados(order) {
            if(this.filtro.campoFiltro == 'Número CDA') {
                this.configTable.sortField = 'cdaPagamento.numeroCda'
            } else if(this.filtro.campoFiltro == 'Situação da Dívida') {
                this.configTable.sortField = 'situacaoDivida'
            } else if(this.filtro.campoFiltro == 'Status') {
                this.configTable.sortField = 'status'
            } else if(this.filtro.campoFiltro == 'Tipo Crédito') {
                this.configTable.sortField = 'cdaPagamento.tipoCredito.descricao'
            } else if(this.filtro.campoFiltro == 'Situação Cadastro') {
                this.configTable.sortField = 'indAtivo'
            }

            this.configTable.sortOrder = order;

            this.consultarCdas();
        },
        excluirCdasModal() {
            this.hideModal('modal-confirmar-excluir');
            this.$refs.loading.showLoading();
            axios.post(`${this.urlApi}/v1/regrasPagamento/excluirCdaPagamento`,
                this.selectedsCdaModal, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                this.selectedsCdaModal = [];
                this.configTable.checkedAll = false;
                this.consultarCdas();
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.configTable.load = false;
                this.$refs.loading.hideLoading();
            })
        },
        abrirModalCdas() {
            this.configTable.checkedAll = false;
            this.configTable.currentPage = 1;
            this.filtros = {
                codPagamento: null,
                numeroCda: null,
                indAtivo: null,
                filtrarSituacaoDivida: null,
                situacaoDivida: null,
                filtrarStatusCredito: null,
                statusCredito: null,
                filtrarTipoCredito: null,
                tipoCredito: null
            };
            this.consultarCdas();
        },

        async consultarCdas() {
            this.$store.commit("setMessages", {});

            let perPageStr = `&perPage=${this.configTable.perPage}`;

            this.filtros.codPagamento = this.pagamento.codPagamento;

            this.configTable.load = true;
            axios.post(`${this.urlApi}/v1/regrasPagamento/consultarCdaPagamento?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`,
                this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                this.listaCdasModal = response.data.resultado;
                this.configTable.rows = response.data.rows;
                this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
            }).catch((error) => {
                this.exibirErro(error)
            }).finally(() => {
                this.configTable.load = false;
            })
        }

    },
    mounted() {
        this.$store.commit("setMessages", {});
        this.urlApi = process.env.VUE_APP_ROOT_API;
        this.token = JSON.parse(this.$store.getters.getUser).access_token;

        let pagamentoEditado = this.$store.getters.getPagamento;
        if(pagamentoEditado) {
            this.$store.commit('setPagamento', null);
            this.obterPagamento(pagamentoEditado);
        } else {
            this.tipoPagamento.indAtivo = true;
            this.cda.indAtivo = true;
        }

        this.listarIndicecs();
        this.listarReceitas();
    }
}
</script>